module.exports = __webpack_public_path__ + "media/bios/zisman-d63f5067.jpg";